import { Button, ModalHead, ScrollBar, toastError, toastSuccess } from 'admination-react'
import { useRef, useState } from 'react'
import { useApp } from '@/core/state/appStore'
import { inviteCoach } from '@/core/data/members'
import { FormRenderer, type FieldHints, type TextInputRules } from '@/core/components/form/FormRenderer'
import { initialFormValues, updateFormField, type FormValues } from '@/core/components/form/formModel'
import { inviteCoachForm } from '@/core/templates'
import { Icon } from 'admination-react'
import { friendlyErrorMessage } from '@/core/lib/dbError'

const SECTION = 'Neuer Coach'

const EMPTY_VALUES: FormValues = initialFormValues(inviteCoachForm)

const INVITE_HINTS: FieldHints = new Map([
  [
    `${SECTION}.E-Mail`,
    {
      tone: 'info',
      text: "Der eingeladene Coach registriert sich mit dieser E-Mail-Adresse. Der Anmeldelink meldet ihn direkt an und ordnet ihn automatisch Ihrer Organisation zu.",
    },
  ],
])

const INVITE_INPUT_RULES: TextInputRules = new Map([[`${SECTION}.E-Mail`, { inputMode: 'email' }]])

function field(values: FormValues, name: string): string {
  const v = values[SECTION]?.[name]
  return typeof v === 'string' ? v : ''
}

export function InviteCoachModal() {
  const { dispatch, reloadMembers } = useApp()
  const scrollerRef = useRef<HTMLElement>(null)
  const [values, setValues] = useState<FormValues>(EMPTY_VALUES)
  const [busy, setBusy] = useState(false)

  const close = () => dispatch({ type: 'CLOSE' })

  const setField = (path: string, v: unknown) => {
    setValues((prev) => updateFormField(prev, path, v))
  }

  const submit = async () => {
    const vorname = field(values, 'Vorname').trim()
    const nachname = field(values, 'Nachname').trim()
    const email = field(values, 'E-Mail').trim()
    if (!vorname || !nachname || !email || busy) return
    setBusy(true)
    try {
      await inviteCoach({ vorname, nachname, email })
      reloadMembers()
      toastSuccess("Coach eingeladen.")
      close()
    } catch (e) {

      console.error("Coach einladen fehlgeschlagen:", e)
      toastError(friendlyErrorMessage(e, "Einladen fehlgeschlagen."))
    } finally {
      setBusy(false)
    }
  }

  const ready = !!(field(values, 'Vorname').trim() && field(values, 'Nachname').trim() && field(values, 'E-Mail').trim())

  return (
    <>
      <ModalHead titleIcon="i-people" title="Coach einladen" actions={<>
          <div className="pill-cluster">
            <div className="pill">
              <Button primaryAction
                type="button"
                iconOnly
                title="Einladen"
                loading={busy}
                disabled={!ready || busy}
                onClick={() => void submit()}
              >
                <Icon name="i-check" />
              </Button>
            </div>

          </div>
        </>} onClose={close} closeLabel="Schließen" />
      <main className="form" data-scroll-host ref={scrollerRef}>
        <FormRenderer
            definition={inviteCoachForm}
            values={values}
            onChange={setField}
            field={(field) => ({
              hint: INVITE_HINTS?.get(field.id),
              ...INVITE_INPUT_RULES?.get(field.id),
            })}
          />
      </main>
      <ScrollBar scrollerRef={scrollerRef} />
    </>
  )
}
